import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import { Icon, InputAdornment, Tooltip } from "@mui/material";
import BMXSelectField from "../../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import { billingType } from "../../../../../../Utils/GlobalVariables/Service/BillingType";
import { useEffect } from "react";
import { get } from "lodash";
import { useDistanceHook } from "../../../../../../Hooks/GoogleHook";
import { useTranslation } from "react-i18next";

const ServiceValuationFormStepThree = (props) => {
  const { t } = useTranslation();
  const { values, form, initialValues } = props;
  const servicePrice = values?.device?.printerModel?.servicePrice;

  useEffect(() => {
    if (values?.billableKilometers < 0) {
      form.change("billableKilometers", 0);
    }

    const billingTypeValue = values?.billingType?.value;

    if (billingTypeValue === billingType?.at(0)?.value) {
      let calcCost = get(servicePrice, "staticRateTransportPrice", 0);
      if (values?.settleTheReturn) {
        calcCost = calcCost * 2;
      }
      form.change("transportCost", calcCost);
    }

    if (billingTypeValue === billingType?.at(1)?.value) {
      let calcCost = get(servicePrice, "rateOneKmTransportPrice", 0) * Number(values?.billableKilometers || 0);
      if (calcCost < servicePrice?.minRateTransportPrice) {
        calcCost = servicePrice?.minRateTransportPrice || 0;
      }
      if (values?.settleTheReturn) {
        calcCost = calcCost * 2;
      }
      form.change("transportCost", calcCost);
    }
    // eslint-disable-next-line 
  }, [values?.billingType, values?.billableKilometers, values?.settleTheReturn])

  const { distance } = useDistanceHook({ to: initialValues?.device?.branch?.address });

  useEffect(() => {
    if (Boolean(values?.googleKm) && Boolean(distance?.value)) {
      form.change("billableKilometers", Number(distance?.value / 1000) || 0)
      return;
    }
    form.change("billableKilometers", initialValues?.billableKilometers);
    // eslint-disable-next-line 
  }, [values?.googleKm])

  useEffect(() => {
    form.change("transportCost", Number(values?.transportCost).toFixed(2));
    // eslint-disable-next-line 
  }, [values?.transportCost])

  useEffect(() => {
    if (Number(distance?.value / 1000) !== values?.billableKilometers && Boolean(values?.billableKilometers) && Boolean(distance?.value)){
      form.change("googleKm", false);
    }
    // eslint-disable-next-line 
  }, [values?.billableKilometers])

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <Row>
        <Col className="d-flex align-items-center">
          <Field
            className="mb-1"
            name="googleKm"
            data-cy="googleKm"
            fieldtype="checkbox"
            component={BMXTextField}
            label={t("global:servicevaluation.googleKm")}
          />
          <Tooltip title={t("global:servicevaluation.googleKmInfo")} placement="right">
            <Icon style={{ color: "var(--BMX-warning)" }}>info</Icon>
          </Tooltip>
        </Col>
      </Row>
      <Row>
        <Col>
          <Field
            className="mb-1"
            name="settleTheReturn"
            data-cy="settleTheReturn"
            fieldtype="checkbox"
            component={BMXTextField}
            label={t("global:servicevaluation.settleTheReturn")}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={3}>
          <Field
            name="billableKilometers"
            type="number"
            component={BMXTextField}
            label={t('global:servicevaluation.billableKilometers')}
            InputProps={{
              endAdornment: (<InputAdornment position="end"><span style={{ fontSize: "12px" }}>km</span></InputAdornment>)
            }}
          />
          <small style={{ color: "var(--BMX-warning)" }}>{t("global:servicevaluation.billableKilometersWarning")}</small>
        </Col>
      </Row>
      <Row>
        <Col xs={3}>
          <Field
            name="billingType"
            values={billingType}
            component={BMXSelectField}
            label={t("global:servicevaluation.billingType")}
          />
        </Col>
        <Col xs={3}>
          <Field
            name="transportCost"
            type="money"
            component={BMXTextField}
            label={t('global:servicevaluation.transportCost')}
          />
        </Col>
      </Row>
    </div >
  );
};

export default ServiceValuationFormStepThree;
